import styled from 'styled-components';

export const AnimationControlStyled = styled.div`
    position: relative;
    height: 44px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;
